import React, { useEffect, useRef, useState } from "react";
import { Briefcase, Search } from "react-feather";
import Input from "../../components/input/Input";
import Dropdown from "../../components/input/Dropdown";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import SearchDropdown from "../../components/input/SearchDropdown";
import Button from "../../components/input/Button";
import { searchVehicleModification } from "../../api/vehicleModificationApi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import VehicleCheckupChange from "../../components/support/vehicle modification/VehicleCheckupChange";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { useSelector } from "react-redux";
import { FORMS, MODULES } from "../../const";

const VehicleModification = () => {
  const [tab, setTab] = useState(1);
  const [activeAccordion, setActiveAccordion] = useState(true);
  const [vehicleCode, setVehicleCode] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [transporter, setTransporter] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [active, setActive] = useState(1);
  const [status, setStatus] = useState(2);
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [searchSubmitting, setSearchSubmitting] = useState(false);
  const [results, setResults] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [transporterReset, setTransporterReset] = useState(false);
  const [manufacturerReset, setManufacturerReset] = useState(false);
  const [vehicleTypeReset, setVehicleTypeReset] = useState(false);

  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.user.permissions[MODULES.Support]);

  const vehicleCheckupDatePermission =
    auth[FORMS.VEHICLE_MODIFICATION.VEHICLE_CHECKUP_DATE.form]?.FIELD?.VIEW;
  const modalRef = useRef(null);
  const gridRef = useRef(null);

  useEffect(() => {
    (async () => {
      const { active: activeOpt, vehicle_status: statusOpt } =
        await getBulkDropdownData([
          { key: "active" },
          { key: "vehicle_status" },
        ]);
      setActiveOptions(activeOpt);
      setStatusOptions(statusOpt);
    })();
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    setSearchSubmitting(true);
    setIsSearchLoading(true);
    setSearchClicked(true);

    const formattedVehicleNo = vehicleNo
      ? vehicleNo
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v.length > 0)
          .join(",")
      : "";

    const searchRequest = {
      vehCode: vehicleCode ? vehicleCode.trim() : "-2",
      vehNo: formattedVehicleNo ? formattedVehicleNo : "-2",
      transporter: transporter ? transporter : -2,
      manufacturer: manufacturer ? manufacturer : -2,
      vehVehicleType: vehicleType ? vehicleType : -2,
      fromDate: fromDate ? fromDate : null,
      toDate: toDate ? toDate : null,
      active: active ? active : -2,
      status: status ? status : -2,
    };

    try {
      const response = await searchVehicleModification(searchRequest);
      setResults(response);
      setIsSearchLoading(false);
    } catch (error) {
      console.log("Error get the search", error);
      setIsSearchLoading(false);
    } finally {
      setSearchSubmitting(false);
    }
  };

  const handleCheckupChange = () => {
    setIsModalOpen(true);
    modalRef.current?.showModal();
  };

  const handleModalSuccess = () => {
    setIsModalOpen(false);
    setSelectedRows([]);
    setSelectedIds([]);
    if (gridRef.current) {
      const selectedNodes = gridRef.current.getSelectedNodes();
      selectedNodes.forEach((node) => {
        node.setSelected(false);
      });
    }
    if (modalRef.current) {
      modalRef.current.close();
    }
  };

  const getActionMenuOptions = () => {
    const actionMenu = [];

    if (vehicleCheckupDatePermission) {
      actionMenu.push({
        key: 1,
        text: "Update Checkup",
        value: 1,
      });
    }
    return actionMenu;
  };

  const actionsMenuChange = (data) => {
    switch (data.value) {
      case 1:
        handleCheckupChange();
        break;
    }
  };

  const handleSelectionChanged = () => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
    if (selectedData.length > 0) {
      setSelectedIds(selectedData.map((item) => item.vehId));
    } else {
      setSelectedIds([]);
    }
  };

  const handleReset = () => {
    setVehicleCode("");
    setVehicleNo("");
    setTransporter("");
    setManufacturer("");
    setVehicleType("");
    setFromDate("");
    setToDate("");
    setActive(1);
    setStatus(2);
    setTransporterReset(true);
    setManufacturerReset(true);
    setVehicleTypeReset(true);
    setSearchClicked(false);
  };

  return (
    <div>
      <div
        className="ui attached tabular"
        style={{ display: "flex", justifyContent: "space-around" }}
      >
        <div className="ui tabular menu top attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => setTab(1)}
          >
            <span>
              <Briefcase size={15} style={{ marginRight: "5px" }} />
            </span>
            Vehicle Search
          </div>
        </div>
      </div>

      <div
        className="ui botton attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion ? "active" : ""}`}
            onClick={() => setActiveAccordion(!activeAccordion)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div className={`content ${activeAccordion ? "active" : ""}`}>
            <form className="ui form">
              <div className="four fields">
                <Input
                  label="Vehicle Code"
                  value={vehicleCode}
                  placeholder="Vehicle Code"
                  onChange={(e) => setVehicleCode(e.target.value)}
                />
                <Input
                  label="Vehicle No"
                  value={vehicleNo}
                  placeholder="Vehicle No"
                  onChange={(e) => setVehicleNo(e.target.value)}
                />
                <SearchDropdown
                  label="Transporter"
                  reset={transporterReset}
                  setReset={setTransporterReset}
                  clearable={true}
                  onClear={() => setTransporter("")}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Transporter",
                  }}
                  onResultSelect={(data) => setTransporter(data)}
                />
                <SearchDropdown
                  label="Manufacturer"
                  reset={manufacturerReset}
                  setReset={setManufacturerReset}
                  clearable={true}
                  onClear={() => setManufacturer("")}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{ type: "manufacturer", value: "" }}
                  onResultSelect={(data) => setManufacturer(data)}
                />
              </div>
              <div className="four fields">
                <SearchDropdown
                  label="Vehicle Type"
                  reset={vehicleTypeReset}
                  setReset={setVehicleTypeReset}
                  clearable={true}
                  onClear={() => setVehicleType("")}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{ type: "vehicle_type", value: "" }}
                  onResultSelect={(data) => setVehicleType(data)}
                />
                <Input
                  label="From Date"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                <Input
                  label="To Date"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
                <Dropdown
                  label="Active"
                  options={activeOptions}
                  value={active}
                  placeholder="Active"
                  onChange={(e, { value }) => setActive(value)}
                />
              </div>
              <div className="four fields">
                <Dropdown
                  label="Status"
                  options={statusOptions}
                  value={status}
                  placeholder="Status"
                  onChange={(e, { value }) => setStatus(value)}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  <Button template="search" onClick={handleSearch} />
                  <Button template="searchReset" onClick={handleReset} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {searchClicked && (
        <>
          {isSearchLoading ? (
            <LoadingSpinner />
          ) : (
            <Grid
              ref={gridRef}
              content={results}
              heading="Vehicles"
              multiRowSelection={true}
              onSelectionChanged={handleSelectionChanged}
              handleActionMenuChange={actionsMenuChange}
              showActionMenu={selectedRows.length > 0 && vehicleCheckupDatePermission}
              actionMenuOptions={getActionMenuOptions()}
              config={[
                {
                  headerName: "Vehicle Code",
                  field: "vehCode",
                  checkboxSelection: true,
                  headerCheckboxSelection: true,
                },
                {
                  headerName: "Vehicle No",
                  field: "vehVehicleNo",
                },

                {
                  headerName: "Transporter",
                  field: "transporter",
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                { headerName: "Manufacturer", field: "manufacturer" },
                {
                  headerName: "Vehicle Type",
                  field: "vehicleType",
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                {
                  headerName: "Status",
                  field: "statusName",
                  cellRenderer: StatusCellStyle,
                },
                {
                  headerName: "Active",
                  field: "activeName",
                  cellRenderer: ActiveCellStyle,
                },
              ]}
            />
          )}
        </>
      )}

      <Modal
        ref={modalRef}
        isOpen={isModalOpen}
        onClose={handleModalSuccess}
        onCloseCleanUp={handleModalSuccess}
        minWidth={"60vw"}
      >
        <VehicleCheckupChange
          key={isModalOpen ? "open" : "closed"}
          selectedIds={selectedIds}
          onSuccess={handleModalSuccess}
          onClose={handleModalSuccess}
        />
      </Modal>
    </div>
  );
};

export default VehicleModification;
